import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingCTLModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreLayoutFeatureCustomLayoutModule } from '@nx-ratenow/core/layout/feature-custom-layout';
import { StoreModule } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import * as fromUserStore from '@nx-ratenow/core/data-access-user';
import {
  HttpConfigInterceptor,
  HttpErrorInterceptor,
  RetryInterceptor,
  LanguageInterceptor,
  JwtInterceptor
} from '@nx-ratenow/core/interceptors';
import { CoreFeatureNotificationModule } from '@nx-ratenow/core/feature-notifications';
import { MtxNativeDatetimeModule } from '@ng-matero/extensions/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CoreDataAccessNavigationCtlModule } from '@nx-ratenow/core/data-access-navigation-ctl';
import {
  SENDINGS_FEATURE_KEY,
  SendingsEffects,
  initialSendingsState,
  sendingsReducer
} from '@nx-ratenow/shared/feature-sendings-details';
import {
  NOTIFICATIONS_FEATURE_KEY,
  NotificationsEffects,
  initialStateNotifications,
  notificationsReducer
} from '@nx-ratenow/core/layout/feature-toolbar';
import { APP_TYPE } from '@nx-ratenow/core/config';
import { AplicationTypeName } from '@nx-ratenow/shared/enums';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingCTLModule,
    MatDatepickerModule,
    MatNativeDateModule,

    CoreFeatureNotificationModule,
    MtxNativeDatetimeModule,
    BrowserModule,

    HttpClientModule,
    BrowserAnimationsModule,

    CoreLayoutFeatureCustomLayoutModule,

    // STORE

    StoreModule.forRoot(
      {
        router: routerReducer
      },
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: false,
          strictActionSerializability: false
        }
      }
    ),
    StoreDevtoolsModule.instrument(),
    EffectsModule.forRoot([]),

    // AUTH - USER

    StoreModule.forFeature(
      fromUserStore.AUTH_FEATURE_KEY,
      fromUserStore.reducer,
      {
        metaReducers: [fromUserStore.localStorageSyncReducer],
        initialState: fromUserStore.initialState
      }
    ),

    EffectsModule.forFeature([fromUserStore.AuthEffects]),

    // NAVIGATION

    CoreDataAccessNavigationCtlModule,

    // SENDINGS
    StoreModule.forFeature(SENDINGS_FEATURE_KEY, sendingsReducer, {
      initialState: initialSendingsState
    }),
    EffectsModule.forFeature([SendingsEffects]),

    // NOTIFICATIONS
    StoreModule.forFeature(NOTIFICATIONS_FEATURE_KEY, notificationsReducer, {
      initialState: initialStateNotifications
    }),
    EffectsModule.forFeature([NotificationsEffects])
  ],
  providers: [
    MatDatepickerModule,
    {
      provide: LOCALE_ID,
      useValue: 'es'
    },
    {
      provide: APP_TYPE,
      useValue: AplicationTypeName.closeTheLoop
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
